import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { INTERACTION_LIST_BASE_CLASSNAME } from './Constants';
import { createInteractionList } from './InteractionList';
createComponents(".".concat(INTERACTION_LIST_BASE_CLASSNAME), createInteractionList, NO_PATTERN_BUSINESS_LOGIC);
